import { Component, OnInit, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Utility } from '../../shared/utility/utility';
import { AppDetailsService } from '../../services/app-details.services';
import { Router } from '@angular/router';
import { EmitterService } from '../../services/emitter.service';
import * as $ from 'jquery';
import { GamingUtility } from '../../gaming/gaming.utility';
window['$'] = window['jQuery'] = $;
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { UserDetailsService } from '../../services/user-details.service';

@Component({
  selector: 'app-slot-game-modal',
  templateUrl: './slot-game-modal.component.html',
  styleUrls: ['./slot-game-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SlotGameModalComponent implements OnInit, OnDestroy {
  imgClick;
  userLogin;
  siteUrlPath: string = environment.siteUrl;
  gameUrlPath: string = environment.gamePath;
  mediaPath: string = environment.mediaPath;
  isCountryAllowed: number = 0;
  langCode;
  destroy$: Subject<boolean> = new Subject<boolean>();

  gameImg;
  gameType;
  hasDemo;
  gameVendor;
  gameTitle;
  gamingDetails;
  modalId = 'slotGameModal';
  gameLaunchUrlPath

  constructor(
    private utils: Utility,
    private appDetails: AppDetailsService,
    private router: Router,
    private emitter: EmitterService,
    private gamingUtils: GamingUtility,
    public userService: UserDetailsService
  ) {
    this.gamingUtils.gameDetails$.pipe(takeUntil(this.destroy$)).subscribe(gameDetails => {
      this.gameImg = gameDetails.gameCode;
      this.gameType = gameDetails.gameType;
      this.hasDemo = gameDetails.hasDemo;
      this.gameTitle = gameDetails.name;
      this.gameVendor = gameDetails.vendorDisplayName;
      this.gameLaunchUrlPath = gameDetails.multilingualUrl['en'];
    });

    this.emitter.loadHomeBanner$.pipe(takeUntil(this.destroy$)).subscribe(message => {
        this.userLogin = this.utils.isUserLoggedIn();
      }
    );

    this.emitter.userCountry$.pipe(takeUntil(this.destroy$)).subscribe(country => {
      if (environment.trustlyCountries.indexOf(country) >= 0) {
        this.getCountry(country);
      } else {
        this.getCountry();
      }
    });

    this.langCode = localStorage.getItem('langCode')
    this.emitter.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });

   }

  ngOnInit() {
    let gameDetails = this.gamingUtils.getGameDetails();
    this.gameImg = gameDetails['gameCode'];
    /* ND-439 multilingual game launch changes can be modified here */
    this.gameLaunchUrlPath = gameDetails['multilingualUrl'] && gameDetails['multilingualUrl']['en'] ? gameDetails['multilingualUrl']['en'] : null;
    this.hasDemo = gameDetails['hasDemo'];
    this.gameTitle = gameDetails['name'];
    this.gameVendor = gameDetails['vendorDisplayName'];

    this.userLogin = this.utils.isUserLoggedIn();
    this.getCountry(this.appDetails.country);
    this.mobileBackButtonDisable();
  }

  closeModal() {
    this.emitter.broadCastIsGameModal(false);
  }

  movetoLogin(gameId, gameLaunchUrlPath) {
    this.utils.closeModal(this.modalId);
    this.appDetails.setGameLauncherParams(gameId, gameLaunchUrlPath);
    this.router.navigate([this.langCode + '/login']);
  }

  gameLauncher(gameType, gameId, gameLaunchUrlPath): void {
    this.closeModal();
    this.userService.gamePlayLaunchChecks(gameId, gameLaunchUrlPath);
  }

  getCountry(country?: String) {
    if (country) {
      this.isCountryAllowed = 1;
    } else {
      this.isCountryAllowed = 2;
    }
  }

  mobileBackButtonDisable() {
    if (window.history && window.history.pushState) {
      window.history.pushState(null, null, null);
      $(window).on('popstate', () => {
        this.closeModal();
      });
    }
  }

  //Bg image if separated
  /*getImageUrlPath(gameImage){
    let image = this.siteUrlPath+'/'+this.gameUrlPath+'/'+gameImage+'/'+gameImage+'-bg-image.jpg';
    let defaultImageGameTileBg = this.siteUrlPath+'/'+this.mediaPath+'/icon-heart-registration.png';
    //return `url(${defaultImageGameTileBg}),url(${image})`
    return `url(${image}),url(${defaultImageGameTileBg})`;
  }*/
  
  //common image
  /*getDefaultUrl(event){
    let defaultGameImage = this.siteUrlPath+'/'+this.mediaPath+'/icon-heart-registration.png';
    
    let defaultImageGameTileBg = this.siteUrlPath+'/'+this.mediaPath+'/icon-heart-registration.png';
    let bgElement = document.getElementById('gameBgImage');
    bgElement.style.backgroundImage = `url(${defaultImageGameTileBg})`;

    event.target.src = defaultGameImage
  }*/
 
  /*getImagePath(gameImg){
    return this.siteUrlPath+'/'+this.gameUrlPath+'/'+gameImg+'/'+gameImg+'.jpg'
  }*/

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
